// ── Service de config legacy de pipelines (loss_reasons) ──────────
// Validação/limpeza dos motivos de perda. I/O via porta.

import type { IWorkspaceConfigRepository, PipelineLossReasonsInfo } from '../ports/IWorkspaceConfigRepository';

export class WorkspaceConfigService {
  constructor(private readonly repo: IWorkspaceConfigRepository) {}

  listPipelinesWithLossReasons = (workspaceId: string): Promise<PipelineLossReasonsInfo[]> => {
    return this.repo.listPipelinesWithLossReasons(workspaceId);
  };

  setPipelineLossReasons = async (pipelineId: string, reasons: unknown[]): Promise<string[]> => {
    if (!pipelineId) throw new Error('pipelineId obrigatório');
    if (!Array.isArray(reasons) || reasons.length === 0) {
      throw new Error('Pelo menos 1 motivo é obrigatório.');
    }

    const clean = reasons
      .map(r => (typeof r === 'string' ? r.trim() : ''))
      .filter(Boolean);

    if (clean.length === 0) {
      throw new Error('Motivos não podem ser todos vazios.');
    }

    await this.repo.updatePipelineLossReasons(pipelineId, clean);
    return clean;
  };
}
